const Map = () => {
  return (
    <div className="w-full rounded-lg mt-4">
    <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3679.191282533681!2d75.86451339999999!3d22.7582815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x396303003df239e1%3A0xe4b3ed89d95e1958!2sPool%20home%20care!5e0!3m2!1sen!2sin!4v1736632930847!5m2!1sen!2sin&mode=lite"
  className="w-full rounded-lg h-[450px]"
  style={{ boxSizing: "border-box", border: "2px solid orange" }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
></iframe>

    </div>
  );
};

export default Map;

